import React from "react";
import { navigate } from "gatsby";
import GatsbyImage from "../../components/GatsbyImages";
import Select from "../Select";

import "./flags.css";

const Flags = ({
  countryHandler,
  country_code,
  customCss,
  countries,
  isLink = false,
  lang,
}) => {
  // const removeDiacritics = string => {
  //   if (!string) return "h"
  //   return string.normalize("NFD").replace(/\p{Diacritic}/gu, "")
  // }
  const flagOptions = countries
    .map(({ url, code, flag, name }, index) => {
      return {
        value: { code, url },
        label: (
          <span className="flagOptions-wrapper" key={index}>
            <GatsbyImage
              src={flag.localFile.childImageSharp.gatsbyImageData}
              ext={flag.ext}
              alt={flag.alternativeText}
              loading={index === 0 ? "eager" : "lazy"}
              height={14}
              width={24}
            />
            <label style={{ color: "black" }}>{name}</label>
          </span>
        ),
      };
    })
    .filter((value) => value !== undefined);

  const rootClass =
    customCss === "remesas" || customCss === "link"
      ? "flags_select_remesas"
      : "flags_select_home";
  const defaultValue = flagOptions.find(
    ({ value }) => value.code === country_code,
  );

  return (
    <Select
      className={`flags_select ${rootClass}`}
      name="flags"
      defaultValue={defaultValue}
      onChange={({ value }) => {
        if (isLink) {
          countryHandler(value.code);
        } else {
          navigate(lang === "en" ? `/en${value.url}` : value.url);
        }
      }}
      options={flagOptions}
    />
  );
};

export default Flags;
